import React from 'react';
import type { LinkedWorklog } from '../../types/plan';

// 「这页 wiki 来自/对应哪几次会话」。结构照抄 components/Todo/LinkedWorklogs.tsx，
// 换一份 wiki 语境的空态文案——留空态而不是整块不渲染：wiki 页面可以一直改，
// 「还没关联」是在告诉读者这里以后会填什么，不是无关信息。

const TYPE_LABELS: Record<string, string> = {
  fix: '修复',
  feature: '功能',
  refactor: '重构',
  docs: '文档',
  config: '配置',
  analysis: '分析',
  chore: '杂务',
  other: '其他',
};

function shortWhen(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

type LinkedWorklogsProps = {
  worklogs: LinkedWorklog[];
};

const LinkedWorklogs: React.FC<LinkedWorklogsProps> = ({ worklogs }) => (
  <div className="mb-[9px]">
    <div className="mb-[7px] flex items-baseline gap-[7px] px-0.5">
      <span className="text-[12.5px] font-semibold">关联的日志</span>
      <span className="rounded-full border border-todo-line bg-todo-card px-1.5 py-px font-mono text-[11px] text-todo-muted">
        {worklogs.length}
      </span>
      <span className="ml-auto text-[11px] text-todo-muted">这页内容来自哪几次会话</span>
    </div>

    {worklogs.length === 0 ? (
      <div className="rounded-lg border border-dashed border-todo-line2 px-[11px] py-[13px] text-[12px] leading-relaxed text-todo-muted">
        还没有工作日志关联到这页。
      </div>
    ) : (
      worklogs.map((worklog) => (
        <a
          key={worklog.slug}
          href={`/worklog/${worklog.slug}`}
          className="mb-[7px] block rounded-lg border border-todo-line bg-todo-card px-[10px] py-2 no-underline last:mb-0 hover:border-todo-line2"
        >
          <div className="mb-0.5 flex items-center gap-1.5">
            <span className="font-mono text-[11px] text-todo-muted">
              {shortWhen(worklog.completed_at)}
            </span>
            <span className="rounded border border-todo-line bg-todo-card2 px-1.5 py-px text-[10.5px] text-todo-ink2">
              {TYPE_LABELS[worklog.task_type] ?? worklog.task_type}
            </span>
            {worklog.linked_by === 'agent' && (
              <span className="ml-auto text-[11px] text-todo-accent" title="AI 关联">
                ✦
              </span>
            )}
          </div>
          <div className="text-[12.5px] leading-snug text-todo-ink">{worklog.title}</div>
        </a>
      ))
    )}
  </div>
);

export default LinkedWorklogs;
